var map = {
	"./lobby_bonuses.png": "b9c6",
	"./lobby_welcome.png": "a0a9",
	"./machines/busy/busy_1.png": "9248",
	"./machines/busy/busy_10.png": "a90f",
	"./machines/busy/busy_11.png": "1fb2",
	"./machines/busy/busy_12.png": "7aa9",
	"./machines/busy/busy_2.png": "124d",
	"./machines/busy/busy_3.png": "1220",
	"./machines/busy/busy_4.png": "2c68",
	"./machines/busy/busy_5.png": "b83b",
	"./machines/busy/busy_6.png": "ef9d",
	"./machines/busy/busy_7.png": "90f8",
	"./machines/busy/busy_8.png": "9691",
	"./machines/busy/busy_9.png": "d59f",
	"./machines/free/basic/free_1.png": "6b36",
	"./machines/free/basic/free_10.png": "6fd4",
	"./machines/free/basic/free_11.png": "86cd",
	"./machines/free/basic/free_12.png": "68f5",
	"./machines/free/basic/free_2.png": "28b8",
	"./machines/free/basic/free_3.png": "2f01",
	"./machines/free/basic/free_4.png": "4386",
	"./machines/free/basic/free_5.png": "f36e",
	"./machines/free/basic/free_6.png": "e8d8",
	"./machines/free/basic/free_7.png": "65d1",
	"./machines/free/basic/free_8.png": "4349",
	"./machines/free/basic/free_9.png": "fb5f",
	"./machines/free/luxe/free_25.png": "acfb",
	"./machines/free/luxe/free_26.png": "9a5d",
	"./machines/free/luxe/free_27.png": "6c28",
	"./machines/free/luxe/free_28.png": "6246",
	"./machines/free/luxe/free_29.png": "6d8e",
	"./machines/free/luxe/free_30.png": "3f37",
	"./machines/free/luxe/free_31.png": "5526",
	"./machines/free/luxe/free_32.png": "461f",
	"./machines/free/luxe/free_33.png": "01a8",
	"./machines/free/luxe/free_34.png": "8d65",
	"./machines/free/luxe/free_35.png": "ef49",
	"./machines/free/luxe/free_36.png": "1a2f",
	"./machines/free/middle/free_13.png": "972d",
	"./machines/free/middle/free_14.png": "2a6a",
	"./machines/free/middle/free_15.png": "4043",
	"./machines/free/middle/free_16.png": "90e9",
	"./machines/free/middle/free_17.png": "adc6",
	"./machines/free/middle/free_18.png": "8374",
	"./machines/free/middle/free_19.png": "da80",
	"./machines/free/middle/free_20.png": "914e",
	"./machines/free/middle/free_21.png": "76d6",
	"./machines/free/middle/free_22.png": "30e5",
	"./machines/free/middle/free_23.png": "bae1",
	"./machines/free/middle/free_24.png": "c615",
	"./machines_mobile/busy/busy_1.png": "c100",
	"./machines_mobile/busy/busy_10.png": "d0b9",
	"./machines_mobile/busy/busy_11.png": "ad55",
	"./machines_mobile/busy/busy_12.png": "db9d",
	"./machines_mobile/busy/busy_2.png": "9f59",
	"./machines_mobile/busy/busy_3.png": "c994",
	"./machines_mobile/busy/busy_4.png": "1027",
	"./machines_mobile/busy/busy_5.png": "77a0",
	"./machines_mobile/busy/busy_6.png": "2dd7",
	"./machines_mobile/busy/busy_7.png": "0535",
	"./machines_mobile/busy/busy_8.png": "e2b2d",
	"./machines_mobile/busy/busy_9.png": "0b30",
	"./machines_mobile/free/basic/free_1.png": "565d",
	"./machines_mobile/free/basic/free_10.png": "b062",
	"./machines_mobile/free/basic/free_11.png": "d0e1",
	"./machines_mobile/free/basic/free_12.png": "d0391",
	"./machines_mobile/free/basic/free_2.png": "cdb1",
	"./machines_mobile/free/basic/free_3.png": "89b7",
	"./machines_mobile/free/basic/free_4.png": "46b0",
	"./machines_mobile/free/basic/free_5.png": "59fd",
	"./machines_mobile/free/basic/free_6.png": "1055",
	"./machines_mobile/free/basic/free_7.png": "1f1c",
	"./machines_mobile/free/basic/free_8.png": "b927",
	"./machines_mobile/free/basic/free_9.png": "cbd4",
	"./machines_mobile/free/luxe/free_25.png": "a3a5",
	"./machines_mobile/free/luxe/free_26.png": "657c",
	"./machines_mobile/free/luxe/free_27.png": "1a35",
	"./machines_mobile/free/luxe/free_28.png": "50fc",
	"./machines_mobile/free/luxe/free_29.png": "9766",
	"./machines_mobile/free/luxe/free_30.png": "adfd",
	"./machines_mobile/free/luxe/free_31.png": "09bf",
	"./machines_mobile/free/luxe/free_32.png": "57d2",
	"./machines_mobile/free/luxe/free_33.png": "cf29",
	"./machines_mobile/free/luxe/free_34.png": "fdbc2",
	"./machines_mobile/free/luxe/free_35.png": "f026",
	"./machines_mobile/free/luxe/free_36.png": "f6f5",
	"./machines_mobile/free/middle/free_13.png": "484f",
	"./machines_mobile/free/middle/free_14.png": "e326",
	"./machines_mobile/free/middle/free_15.png": "31a0",
	"./machines_mobile/free/middle/free_16.png": "ebf3",
	"./machines_mobile/free/middle/free_17.png": "7066",
	"./machines_mobile/free/middle/free_18.png": "8d01",
	"./machines_mobile/free/middle/free_19.png": "b932",
	"./machines_mobile/free/middle/free_20.png": "4810",
	"./machines_mobile/free/middle/free_21.png": "8879",
	"./machines_mobile/free/middle/free_22.png": "76c0",
	"./machines_mobile/free/middle/free_23.png": "cd9d",
	"./machines_mobile/free/middle/free_24.png": "46d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b70c";